/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  FspDto,
  FspType,
  GetFspByFspTypeParams
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Get a list of all Financial Service Providers
 * @summary Get all FSPs
 */
export const getAllFsps1 = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FspDto[]>(
      {url: `/frontend/admin/fsps`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllFsps1InfiniteQueryKey = () => {
    return [
    'infinite', `/frontend/admin/fsps`
    ] as const;
    }

export const getGetAllFsps1QueryKey = () => {
    return [
    `/frontend/admin/fsps`
    ] as const;
    }

    
export const getGetAllFsps1InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllFsps1>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFsps1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllFsps1InfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllFsps1>>> = ({ signal }) => getAllFsps1(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFsps1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllFsps1InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllFsps1>>>
export type GetAllFsps1InfiniteQueryError = unknown


export function useGetAllFsps1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFsps1>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFsps1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFsps1>>,
          TError,
          Awaited<ReturnType<typeof getAllFsps1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFsps1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFsps1>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFsps1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFsps1>>,
          TError,
          Awaited<ReturnType<typeof getAllFsps1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFsps1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFsps1>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFsps1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all FSPs
 */

export function useGetAllFsps1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllFsps1>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllFsps1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllFsps1InfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllFsps1QueryOptions = <TData = Awaited<ReturnType<typeof getAllFsps1>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFsps1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllFsps1QueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllFsps1>>> = ({ signal }) => getAllFsps1(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllFsps1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllFsps1QueryResult = NonNullable<Awaited<ReturnType<typeof getAllFsps1>>>
export type GetAllFsps1QueryError = unknown


export function useGetAllFsps1<TData = Awaited<ReturnType<typeof getAllFsps1>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFsps1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFsps1>>,
          TError,
          Awaited<ReturnType<typeof getAllFsps1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFsps1<TData = Awaited<ReturnType<typeof getAllFsps1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFsps1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllFsps1>>,
          TError,
          Awaited<ReturnType<typeof getAllFsps1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllFsps1<TData = Awaited<ReturnType<typeof getAllFsps1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFsps1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all FSPs
 */

export function useGetAllFsps1<TData = Awaited<ReturnType<typeof getAllFsps1>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllFsps1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllFsps1QueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a specific FSP by its code
 * @summary Get FSP by ID
 */
export const getFspById = (
    code: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FspDto>(
      {url: `/frontend/admin/fsps/${code}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetFspByIdInfiniteQueryKey = (code?: string,) => {
    return [
    'infinite', `/frontend/admin/fsps/${code}`
    ] as const;
    }

export const getGetFspByIdQueryKey = (code?: string,) => {
    return [
    `/frontend/admin/fsps/${code}`
    ] as const;
    }

    
export const getGetFspByIdInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getFspById>>>, TError = unknown>(code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFspByIdInfiniteQueryKey(code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFspById>>> = ({ signal }) => getFspById(code, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(code), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFspByIdInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getFspById>>>
export type GetFspByIdInfiniteQueryError = unknown


export function useGetFspByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspById>>>, TError = unknown>(
 code: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspById>>,
          TError,
          Awaited<ReturnType<typeof getFspById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspById>>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspById>>,
          TError,
          Awaited<ReturnType<typeof getFspById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspById>>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get FSP by ID
 */

export function useGetFspByIdInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspById>>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFspByIdInfiniteQueryOptions(code,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetFspByIdQueryOptions = <TData = Awaited<ReturnType<typeof getFspById>>, TError = unknown>(code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFspByIdQueryKey(code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFspById>>> = ({ signal }) => getFspById(code, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFspById>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFspByIdQueryResult = NonNullable<Awaited<ReturnType<typeof getFspById>>>
export type GetFspByIdQueryError = unknown


export function useGetFspById<TData = Awaited<ReturnType<typeof getFspById>>, TError = unknown>(
 code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspById>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspById>>,
          TError,
          Awaited<ReturnType<typeof getFspById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspById<TData = Awaited<ReturnType<typeof getFspById>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspById>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspById>>,
          TError,
          Awaited<ReturnType<typeof getFspById>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspById<TData = Awaited<ReturnType<typeof getFspById>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get FSP by ID
 */

export function useGetFspById<TData = Awaited<ReturnType<typeof getFspById>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspById>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFspByIdQueryOptions(code,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get FSPs filtered by type (MNO or BANK)
 * @summary Get FSPs by type
 */
export const getFspsByType = (
    fspType: FspType,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FspDto[]>(
      {url: `/frontend/admin/fsps/type/${fspType}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetFspsByTypeInfiniteQueryKey = (fspType?: FspType,) => {
    return [
    'infinite', `/frontend/admin/fsps/type/${fspType}`
    ] as const;
    }

export const getGetFspsByTypeQueryKey = (fspType?: FspType,) => {
    return [
    `/frontend/admin/fsps/type/${fspType}`
    ] as const;
    }

    
export const getGetFspsByTypeInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getFspsByType>>>, TError = unknown>(fspType: FspType, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFspsByTypeInfiniteQueryKey(fspType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFspsByType>>> = ({ signal }) => getFspsByType(fspType, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fspType), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspsByType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFspsByTypeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getFspsByType>>>
export type GetFspsByTypeInfiniteQueryError = unknown


export function useGetFspsByTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspsByType>>>, TError = unknown>(
 fspType: FspType, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspsByType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspsByType>>,
          TError,
          Awaited<ReturnType<typeof getFspsByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspsByTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspsByType>>>, TError = unknown>(
 fspType: FspType, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspsByType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspsByType>>,
          TError,
          Awaited<ReturnType<typeof getFspsByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspsByTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspsByType>>>, TError = unknown>(
 fspType: FspType, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get FSPs by type
 */

export function useGetFspsByTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspsByType>>>, TError = unknown>(
 fspType: FspType, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFspsByTypeInfiniteQueryOptions(fspType,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetFspsByTypeQueryOptions = <TData = Awaited<ReturnType<typeof getFspsByType>>, TError = unknown>(fspType: FspType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFspsByTypeQueryKey(fspType);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFspsByType>>> = ({ signal }) => getFspsByType(fspType, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fspType), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFspsByType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFspsByTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getFspsByType>>>
export type GetFspsByTypeQueryError = unknown


export function useGetFspsByType<TData = Awaited<ReturnType<typeof getFspsByType>>, TError = unknown>(
 fspType: FspType, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspsByType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspsByType>>,
          TError,
          Awaited<ReturnType<typeof getFspsByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspsByType<TData = Awaited<ReturnType<typeof getFspsByType>>, TError = unknown>(
 fspType: FspType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspsByType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspsByType>>,
          TError,
          Awaited<ReturnType<typeof getFspsByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspsByType<TData = Awaited<ReturnType<typeof getFspsByType>>, TError = unknown>(
 fspType: FspType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get FSPs by type
 */

export function useGetFspsByType<TData = Awaited<ReturnType<typeof getFspsByType>>, TError = unknown>(
 fspType: FspType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFspsByTypeQueryOptions(fspType,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get a specific FSP by its code
 * @summary Get FSP by code
 */
export const getFspByCode1 = (
    code: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FspDto>(
      {url: `/frontend/admin/fsps/code/${code}`, method: 'GET', signal
    },
      options);
    }
  



export const getGetFspByCode1InfiniteQueryKey = (code?: string,) => {
    return [
    'infinite', `/frontend/admin/fsps/code/${code}`
    ] as const;
    }

export const getGetFspByCode1QueryKey = (code?: string,) => {
    return [
    `/frontend/admin/fsps/code/${code}`
    ] as const;
    }

    
export const getGetFspByCode1InfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getFspByCode1>>>, TError = unknown>(code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspByCode1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFspByCode1InfiniteQueryKey(code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFspByCode1>>> = ({ signal }) => getFspByCode1(code, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(code), ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspByCode1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFspByCode1InfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getFspByCode1>>>
export type GetFspByCode1InfiniteQueryError = unknown


export function useGetFspByCode1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspByCode1>>>, TError = unknown>(
 code: string, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspByCode1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspByCode1>>,
          TError,
          Awaited<ReturnType<typeof getFspByCode1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspByCode1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspByCode1>>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspByCode1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspByCode1>>,
          TError,
          Awaited<ReturnType<typeof getFspByCode1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspByCode1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspByCode1>>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspByCode1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get FSP by code
 */

export function useGetFspByCode1Infinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspByCode1>>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspByCode1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFspByCode1InfiniteQueryOptions(code,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetFspByCode1QueryOptions = <TData = Awaited<ReturnType<typeof getFspByCode1>>, TError = unknown>(code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspByCode1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFspByCode1QueryKey(code);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFspByCode1>>> = ({ signal }) => getFspByCode1(code, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(code), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFspByCode1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFspByCode1QueryResult = NonNullable<Awaited<ReturnType<typeof getFspByCode1>>>
export type GetFspByCode1QueryError = unknown


export function useGetFspByCode1<TData = Awaited<ReturnType<typeof getFspByCode1>>, TError = unknown>(
 code: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspByCode1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspByCode1>>,
          TError,
          Awaited<ReturnType<typeof getFspByCode1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspByCode1<TData = Awaited<ReturnType<typeof getFspByCode1>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspByCode1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspByCode1>>,
          TError,
          Awaited<ReturnType<typeof getFspByCode1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspByCode1<TData = Awaited<ReturnType<typeof getFspByCode1>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspByCode1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get FSP by code
 */

export function useGetFspByCode1<TData = Awaited<ReturnType<typeof getFspByCode1>>, TError = unknown>(
 code: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspByCode1>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFspByCode1QueryOptions(code,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get FSPs filtered by type
 * @summary Get FSPs by type
 */
export const getFspByFspType = (
    params: GetFspByFspTypeParams,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<FspDto[]>(
      {url: `/frontend/admin/fsps/by-type`, method: 'GET',
        params, signal
    },
      options);
    }
  



export const getGetFspByFspTypeInfiniteQueryKey = (params?: GetFspByFspTypeParams,) => {
    return [
    'infinite', `/frontend/admin/fsps/by-type`, ...(params ? [params]: [])
    ] as const;
    }

export const getGetFspByFspTypeQueryKey = (params?: GetFspByFspTypeParams,) => {
    return [
    `/frontend/admin/fsps/by-type`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetFspByFspTypeInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getFspByFspType>>>, TError = unknown>(params: GetFspByFspTypeParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspByFspType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFspByFspTypeInfiniteQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFspByFspType>>> = ({ signal }) => getFspByFspType(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspByFspType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFspByFspTypeInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getFspByFspType>>>
export type GetFspByFspTypeInfiniteQueryError = unknown


export function useGetFspByFspTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspByFspType>>>, TError = unknown>(
 params: GetFspByFspTypeParams, options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspByFspType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspByFspType>>,
          TError,
          Awaited<ReturnType<typeof getFspByFspType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspByFspTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspByFspType>>>, TError = unknown>(
 params: GetFspByFspTypeParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspByFspType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspByFspType>>,
          TError,
          Awaited<ReturnType<typeof getFspByFspType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspByFspTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspByFspType>>>, TError = unknown>(
 params: GetFspByFspTypeParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspByFspType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get FSPs by type
 */

export function useGetFspByFspTypeInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getFspByFspType>>>, TError = unknown>(
 params: GetFspByFspTypeParams, options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getFspByFspType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFspByFspTypeInfiniteQueryOptions(params,options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetFspByFspTypeQueryOptions = <TData = Awaited<ReturnType<typeof getFspByFspType>>, TError = unknown>(params: GetFspByFspTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspByFspType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetFspByFspTypeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getFspByFspType>>> = ({ signal }) => getFspByFspType(params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getFspByFspType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetFspByFspTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getFspByFspType>>>
export type GetFspByFspTypeQueryError = unknown


export function useGetFspByFspType<TData = Awaited<ReturnType<typeof getFspByFspType>>, TError = unknown>(
 params: GetFspByFspTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspByFspType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspByFspType>>,
          TError,
          Awaited<ReturnType<typeof getFspByFspType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspByFspType<TData = Awaited<ReturnType<typeof getFspByFspType>>, TError = unknown>(
 params: GetFspByFspTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspByFspType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getFspByFspType>>,
          TError,
          Awaited<ReturnType<typeof getFspByFspType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetFspByFspType<TData = Awaited<ReturnType<typeof getFspByFspType>>, TError = unknown>(
 params: GetFspByFspTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspByFspType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get FSPs by type
 */

export function useGetFspByFspType<TData = Awaited<ReturnType<typeof getFspByFspType>>, TError = unknown>(
 params: GetFspByFspTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getFspByFspType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetFspByFspTypeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




